import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { QuickpanelComponent } from "./quickpanel.component";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { RouterModule } from "@angular/router";
import { MatRippleModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatToolbarModule } from "@angular/material/toolbar";
import { ScrollbarModule } from "../../components/scrollbar/scrollbar.module";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { IconModule } from "@visurel/iconify-angular";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [QuickpanelComponent],
  imports: [
    CommonModule,
    MatListModule,
    MatProgressBarModule,
    RouterModule,
    MatRippleModule,
    MatExpansionModule,
    MatToolbarModule,
    ScrollbarModule,
    MatButtonModule,
    MatIconModule,
    FlexLayoutModule,
    IconModule,
    TranslateModule
  ],
  exports: [QuickpanelComponent],
})
export class QuickpanelModule {}
